import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import DataApi from '../../../api/data/DataApi'
import { HttpError } from '../../../types/common'
import { showErrorToast } from '../../../utils/errors'
import { queryNames } from '../../queries'

const dataApi = DataApi.getInstance()

export function useRemoveStripeConfig() {
  const texts = useTranslation().t
  const queryClient = useQueryClient()

  const mutation = useMutation(async () => {
    const { data } = await dataApi.removeStripeConfig()
    return data
  }, {
    onSuccess: () => {
      queryClient.setQueryData([queryNames.getStripeConfig], () => {
        return null
      })
      queryClient.invalidateQueries([queryNames.getTrainerProductList])
      toast.success(texts('successes:stripe_config_updated'))
    },
    onError: (error: AxiosError<HttpError>) => {
      showErrorToast(error, texts)
    }
  })
  return mutation
}